<template>
    <v-layout>
         <!-- Apply for PC or Laptop -->
        <v-container class="hidden-sm-and-down">
            <v80d3010pc/>
        </v-container>
        <!-- Apply for Mobile -->
        <v-container class="hidden-md-and-up">
            <v80d3010m/>
        </v-container>
    </v-layout>    
</template>

<script>

import v80d3010m from './popup/v80d3010m'
import v80d3010pc from './popup/v80d3010pc'


export default {
    
    name: "v80d3010",
    components: {
       v80d3010m,
       v80d3010pc 
    },
    props:{
       
    },
    data: () => ({  
       

    }),    
    mounted() {

     
    },
    methods : {

    }

    
}
</script>